export default "__VITE_ASSET__BDa1HY79__"